module.exports = __webpack_public_path__ + "assets/img/3_1389_big.10ca135f.jpg";